import { getDashboardClubsControllerListQueryKey } from "@/api/__generated__/dashboard-clubs/dashboard-clubs";
import { MessageKey } from "@/i18n";
import { ClubMemberStatus, ClubStatus, ClubsTableColumn, ClubType } from "@/types/club.types";

export const CLUBS_INVALIDATE_KEYS = [getDashboardClubsControllerListQueryKey()];

export const CLUBS_TABLE_COLUMN_LABELS: { [key in ClubsTableColumn]: MessageKey } = {
  number: "general.columns.number",
  name: "general.columns.name",
  clubType: "club.columns.type",
  tournaments: "club.columns.tournaments",
  members: "club.columns.members",
  onlineBooking: "club.columns.onlineBooking",
  platform: "club.columns.platform",
  organization: "club.columns.organization",
  sports: "club.columns.sports",
  status: "general.columns.status",
};

export const CLUB_STATUS_LABELS: { [key in ClubStatus]: MessageKey } = {
  active: "club.status.active",
  inactive: "club.status.inactive",
};

export const CLUB_MEMBER_STATUS_LABELS: { [key in ClubMemberStatus]: MessageKey } = {
  approved: "club.enums.memberStatus.approved",
  pending: "club.enums.memberStatus.pending",
  declined: "club.enums.memberStatus.declined",
};

export const CLUB_TYPE_LABELS: { [key in ClubType]: MessageKey } = {
  club: "club.type.club",
  municipality: "club.type.municipality",
  community: "club.type.community",
  educationalInstitution: "club.type.educationalInstitution",
};
